import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Home";
import Admin from "./features/auth/pages/Admin";
import PosTerminal from "./features/pos/pages/PosTerminal";
import HarvestShellDemo from "./features/demo/HarvestShellDemo";
import ScaleDemo from "./features/demo/ScaleDemo";
import DesignSystemDemo from "./features/demo/DesignSystemDemo";
import DashboardDrawerDemo from "./features/demo/DashboardDrawerDemo";
import PermissionGuard from "./shared/ui/PermissionGuard";
import homePath, { readSessionHomePath as readHome } from "./shared/lib/homePath";
import { startSessionHeartbeat } from "./shared/lib/session";

const readSessionHomePath = typeof readHome === "function"
  ? readHome
  : homePath.readSessionHomePath;

const App = () => {
  useEffect(() => {
    startSessionHeartbeat();
  }, []);

  const isUserAuthenticated = () => {
    const sessionToken = localStorage.getItem("sessionToken");
    return typeof sessionToken === "string" && sessionToken.trim() !== "";
  };
  return (
    <Router>
      <Routes>
        {/* Visual shell recreation — no app layout, no auth required to preview */}
        <Route path="/harvest-demo" element={<HarvestShellDemo />} />
        {/* Scale hardware demo — Web Serial (Chrome/Edge), no auth required */}
        <Route path="/scale-demo" element={<ScaleDemo />} />
        {/* Design-system reference pages — build their own chrome, no app sidebar, no auth required */}
        <Route path="/design-system" element={<DesignSystemDemo />} />
        <Route path="/dashboard-demo" element={<DashboardDrawerDemo />} />
        {/* Kiosk route: rendered without AppLayout (no sidebar/header) for a true full-screen POS */}
        <Route
          path="/pos"
          element={
            isUserAuthenticated() ? (
              <PermissionGuard
                permission="pos.sell"
                redirectTo={readSessionHomePath()}
              >
                <PosTerminal />
              </PermissionGuard>
            ) : (
              <Admin />
            )
          }
        />
        <Route path="*" element={isUserAuthenticated() ? <Home /> : <Admin />} />
      </Routes>
    </Router>
  );
};

export default App;
